module.exports = __webpack_public_path__ + "img/y- (21).68392814.jpg";